import * as React from "react";
import type { SVGProps } from "react";
const SvgPrimarySpf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      stroke="#1D1D1D"
      strokeWidth={0.575}
      d="M6.902 14.33v3.733c0 .202.106.388.29.473.506.234 1.652.664 3.228.664s2.722-.43 3.229-.664a.51.51 0 0 0 .289-.473V14.33m-7.036 0L5.846 2.189a.49.49 0 0 1 .232-.474C6.608 1.412 7.978.8 10.42.8s3.812.612 4.342.915a.49.49 0 0 1 .231.474l-1.055 12.14m-7.036 0s1.353.812 3.518.812 3.518-.811 3.518-.811"
    />
  </svg>
);
export default SvgPrimarySpf;
